import React from 'react';
import PropTypes from 'prop-types';

import Modal, { ModalClose } from '../ui/Modal';
import Title from '../ui/Title';
import RichText from '../ui/RichText';
import { StyledModalContent } from './NewContentModal.style';

import { dictionaryItem } from '../../hocs/withDictionary';
import { modalContentMaxHeight, ModalFooter } from '../ui/Modal/Modal.style';
import { ButtonBordered } from '../ui/Button';
import GenericScrollContainer from '../GenericScrollContainer/GenericScrollContainer';

const NewContentModal = ({ active, contentKey, onClose }) => (
  <Modal active={active} onClickOutside={onClose} overlay>
    <StyledModalContent>
      <ModalClose onClick={onClose} />
      <Title
        tag={2}
        size={1}
        marginBottom="1rem"
        dictionary={dictionaryItem('NewContentModal', contentKey)}
      />
      <GenericScrollContainer
        customContainerStyles={{
          maxHeight: modalContentMaxHeight,
        }}
      >
        <RichText dictionary={dictionaryItem('NewContentModal', contentKey)} />
      </GenericScrollContainer>
      <ModalFooter flex justify="center" padding="0">
        <ButtonBordered
          onClick={onClose}
          dictionary={dictionaryItem('NewContentModal', contentKey, 'Dismiss')}
        />
      </ModalFooter>
    </StyledModalContent>
  </Modal>
);

NewContentModal.propTypes = {
  active: PropTypes.bool,
  contentKey: PropTypes.string,
  onClose: PropTypes.func,
};

NewContentModal.defaultProps = {
  active: false,
  contentKey: '',
  onClose: () => {},
};

export default NewContentModal;
